/**
 * Filter node configuration type and validation
 */

export type FilterConfigType = {
  expression: string;
};

export const defaultFilterConfig: FilterConfigType = {
  expression: '',
};

export const validateFilterConfig = (
  config: FilterConfigType,
): Record<string, string> => {
  const errors: Record<string, string> = {};

  if (!config.expression || config.expression.trim() === '') {
    errors.expression = 'Expression is required';
  }

  return errors;
};

/**
 * Get preview text for the node display
 */
export const getFilterPreviewText = (config: FilterConfigType): string =>
  config.expression || 'Configure filter';
